<mat-tab-group [(selectedIndex)]="selectedTab">
  <!-- Pendientes de aprobación (con badge de conteo) -->
  <mat-tab>
    <ng-template mat-tab-label>
      <span>Pendientes</span>
      @if (totalPendientes) {
        <span class="tab-contador">
          {{ totalPendientes.toLocaleString('es-AR') }}
        </span>
      }
    </ng-template>
    <ng-template matTabContent>
      <app-tabla
        [datos]="datosPendientes"
        [columnas]="columnas"
        [totalCount]="totalPendientes"
        [(query)]="queryPendientes"
        (queryChange)="listarPendientes()"
        [filtros]="filtrosPendientes"
        [firstLastButtons]="false"
        [goto]="false"
        [emptyState]="{
          title: 'No hay pedidos de materiales por aprobar',
          subtitle:
            'Los pedidos de los técnicos aparecen acá hasta que se aprueban o se anulan.',
        }"
      ></app-tabla>
    </ng-template>
  </mat-tab>

  <!-- Historial: usados, asignados, devueltos, aprobados, anulados… -->
  <mat-tab label="Historial">
    <ng-template matTabContent>
      <app-tabla
        [datos]="datosHistorial"
        [columnas]="columnas"
        [totalCount]="totalHistorial"
        [(query)]="queryHistorial"
        (queryChange)="listarHistorial()"
        [filtros]="filtrosHistorial"
        [firstLastButtons]="false"
        [goto]="false"
        [emptyState]="{
          title: 'Todavía no hay movimientos de materiales',
          subtitle: 'Probá cambiando los filtros.',
        }"
      ></app-tabla>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<app-image-viewer
  [images]="viewerImagenes"
  [(index)]="viewerIndex"
  [isVisible]="viewerVisible"
  (closeViewer)="viewerVisible = false"
></app-image-viewer>
